<template>
  <div class="aside">
    <div class="find">
      <el-input class="find-input" v-model="filterText" placeholder="搜索" size="small" />
      <el-button size="small" @click="changeEquip">全部</el-button>
    </div>
    <el-tree
        v-loading = "treeLoading"
        element-loading-text = "加载中..."
        element-loading-background="#303749"
        :accordion=true
        :data="treeData"
        node-key="id"
        ref="mytree"
        :filter-node-method="filterNode"
        :render-content="renderContent"
        @node-click="handleNodeClick"
    >
    </el-tree>
  </div>
</template>

<script>
import {ref, onBeforeMount, nextTick, computed, watch,onMounted} from 'vue'
import {useStore} from 'vuex'
import {useRoute, useRouter} from 'vue-router'
import axios from 'axios'
import Color from 'element-plus/es/components/color-picker/src/color'
import { log } from 'console'
import {ElMessage} from "element-plus";
export default {
  name:'ASside',
  setup(props, ctx) {
    let dataSource=ref(4);
    var CancelToken = axios.CancelToken;
    var source = CancelToken.source();
    let treeData = ref(null);

    const mytree = ref(null);
    let store = useStore();
    const route = new useRouter();
    let nodeColor=ref('white');
    const filterText = ref('');
    let tWidth = computed(() => {
      return store.state.treeWidth;
    })
    let treeLoading = ref(false);


    watch(filterText, (val) => {
      filterTree(val)
    })
    watch(store.state.nodeData,(val)=>{
      console.log("nodeData发生了变化！",val)
    })
    //页面变动
    watch(() =>route.currentRoute.value.path,(newValue,oldValue)=> {

      if(newValue.indexOf("RealtStatus")!=-1)
      {
        dataSource.value=1;
      }
      else if(newValue.indexOf("OffLineStatus")!=-1)
      {
        dataSource.value=4;
      }
      else if(newValue.indexOf("SensorError")!=-1)
      {

        dataSource.value=0;
      }
      else if(newValue.indexOf("ConfigPrivilege"!=-1))
      {
        dataSource.value=0;
      }
      else if(newValue.indexOf("OverView"!=-1))
      {
        dataSource.value=0;
        console.log("这是首页啊")
      }
      console.log("页面变动，更新树")
      updateTree()
    })



    let updateTree=()=>{
      changeEquip();
      source.cancel('取消上一次getall请求')
      getEquip();
    }

    //整形
    function transformData(data) {
      return data.map(group => {
        const companyDataList = group.companyDataList.map(company => {
          const factoryDataList = company.factoryDataList.map(factory => {
            const unitDataList = factory.unitDataList.map(unit => {
              const equipmentDataList = unit.equipmentDataList.map(equipment => {
                let tmp1 = {};
                if (equipment.alarmLevel == 1) {
                  tmp1['icon'] = 'iconfont icon-dian1 level1'; //智能一级
                } else if (equipment.alarmLevel == 2) {
                  tmp1['icon'] = 'iconfont icon-dian1 level2'; //智能二级
                } else if (equipment.alarmLevel == 3) {
                  tmp1['icon'] = 'iconfont icon-dian1 level3'; //智能三级
                } else if (equipment.alarmLevel == 4) {
                  tmp1['icon'] = 'iconfont icon-dian1 hLevel'; //固定高报
                } else if (equipment.alarmLevel == 5) {
                  tmp1['icon'] = 'iconfont icon-dian1 hhLevel'; //固定高高报
                } else if (equipment.alarmLevel == 0) {
                  tmp1['icon'] = 'iconfont icon-dian1 green'; //正常
                } else if (equipment.alarmLevel == -1) {
                  tmp1['icon'] = 'iconfont icon-dian1 tingji'; //停机
                } else if (equipment.alarmLevel == -2) {
                  tmp1['icon'] = 'iconfont icon-dian1 duanwang'; //断网
                }
                tmp1['title'] = equipment.alarmAlias;
                return {
                  label: equipment.equipmentName,
                  id: equipment.equipmentId,
                  node: ["empty", "empty", "empty", "empty", equipment.equipmentUuid, "empty"],
                  dataSource: equipment.dataSource.toString(),
                  ...tmp1
                };
              });
              return {
                label: unit.unitName,
                id: unit.unitId,
                node: ["empty", "empty", "empty", unit.unitName, "empty", "empty"],
                children: equipmentDataList,
                dataSource: equipmentDataList.length ? equipmentDataList[0].dataSource : "0",

              };
            });
            return {
              label: factory.factoryName,
              id: factory.factoryId,
              node: ["empty", "empty", factory.factoryName, "empty", "empty", "empty"],
              dataSource: unitDataList.length ? unitDataList[0].dataSource : "0",
              children: unitDataList
            };
          });
          return {
            label: company.companyName,
            id: company.companyId,
            node: ["empty", company.companyName, "empty", "empty", "empty", "empty"],
            dataSource: factoryDataList.length ? factoryDataList[0].dataSource : "0",
            children: factoryDataList
          };
        });
        return {
          label: group.groupName,
          id: group.groupId,
          node: [group.groupName, "empty", "empty", "empty", "empty", "empty"],
          dataSource: companyDataList.length ? companyDataList[0].dataSource : "0",
          children: companyDataList
        };
      });
    }

    function updateNodes(tree, ancestors = []) {
      return tree.map(node => {
        // Create a new node array, maintaining unused 'empty' slots
        let newNodeArray = [...node.node];
        newNodeArray.forEach((value, index) => {
          if (value === "empty") {
            newNodeArray[index] = (ancestors[index] || "empty");
          }
        });

        const updatedNode = {
          ...node,
          node: newNodeArray
        };

        if (node.children) {
          updatedNode.children = updateNodes(node.children, [...ancestors, node.label]);
        }

        return updatedNode;
      });
    }


    //获取设备准备建树
    let getEquip = () => {

      axios.get('/api1/equipments/getDataByUsername/'+(localStorage.getItem("username"))
          ,{
            cancelToken: source.token
          }
      )
          .catch(err=>{
            localStorage.getItem("username")
            console.log(err)
          })
          .then(res => {
            if (res.data.code == 200) {
              let tmpTreeData = [];
              tmpTreeData = transformData(res.data.data)

              tmpTreeData = updateNodes(tmpTreeData);
              treeData.value = tmpTreeData;
              //设置浏览器本地存储设备树
              localStorage.setItem("treeData",JSON.stringify(tmpTreeData));

              nextTick(() => {
                treeLoading.value = false
                filterTree("");
                if (route.currentRoute.value.query.nodeId!=null) {
                  //console.log('route.currentRoute.value.query.nodeId',route.currentRoute.value.query.nodeId);
                  store.state.nodeId = decodeURIComponent(route.currentRoute.value.query.nodeId)
                  // mytree.value.setCurrentKey(store.state.nodeId);
                  var datas=mytree.value.getNode(decodeURIComponent(route.currentRoute.value.query.nodeId))
                  console.log("mytree----->",datas)
                  handleNodeClick(datas.data,datas,"")
                }
              })
            }
            else{
              ElMessage.error(res.data.message);
            }
          })
    }
    let renderContent = (h, {node, data, store}) => {
      return h(
          "span", [
            h("h", {
              class: data.icon,
              style: {
                display: 'inline-block',
                fontSize: '10px',
                // color:nodeColor.value
              }
            }),
            h("span", {
              // domProps: {title: data.title},
              style: {
                marginLeft: '5px',
                fontSize: '13px',
              },

            }, node.label)
          ]
      )
    }
    let handleNodeClick = ((data,b,c) => {
      console.log("treedata++++++++",treeData)
      console.log("store.state.nodedata===>" ,store.state.nodeData);
      store.state.nodeLable = data.label;
      store.state.nodeId = data.id;
      store.state.nodeData = data;
      route.push({
        query: {
          nodeId: encodeURIComponent(data.id)
        }
      })


      console.log("data====>",data);
      console.log("b====>",b);
      //
      // let depth = 5;
      // for(let i = 5;i>=1;i--)
      // {
      //   if(data.node[i]!=="empty"&&data.node[i]!==" ")
      //   {
      //     break;
      //   }
      //   depth--;
      // }
      //
      // let parentnode = b.parent;
      // for(let i=depth;i>=1;i--)
      // {
      //   console.log("index:",i);
      //   if(data.node[i]!=="empty")
      //   {
      //     store.state.nodeData.node[i-1]=parentnode.data.label;
      //     parentnode = parentnode.parent;
      //   }
      //
      //
      //
      //   // if(data.node[i]===data.label)
      //   // {
      //   //   console.log(b.parent.data.label);
      //   //
      //   //   store.state.nodeData.node[i-1]=b.parent.data.label;
      //   //   break;
      //   // }
      // }
      // console.log(store.state);
    })
    const filterNode = (param, data, node) => {
      var value = param.val;
      if(data.dataSource!=param.dataSource && param.dataSource!=0)
      {
        return false;
      }
      if (!value) return true;
      value = value.toUpperCase()
      if (data.label.toUpperCase().indexOf(value) == -1 && !data.children) {
        let nowNode = node.parent;
        while (nowNode) {
          if (!Array.isArray(nowNode.data) && nowNode.data.label.toUpperCase().indexOf(value) !== -1) {
            return true;
          }
          nowNode = nowNode.parent;
        }
        return false;
      }
      return data.label.toUpperCase().indexOf(value) !== -1;
    }
    const changeEquip = () => {
      filterText.value=null;
      mytree.value.setCurrentKey(null);
      route.push({
        query: {nodeId:null}
      }).then(()=>{
        store.state.nodeId = "";
        store.state.nodeLable =  '';
        store.state.nodeData =  {node:['empty','empty','empty','empty','empty','empty']}
        filterTree("");
      });

    }
    const expandAll=(bool)=> {

      for (let i in mytree.value.store.nodesMap) {

        mytree.value.store.nodesMap[i].expanded=false
      }

    }

    // TODO:考虑后端，筛选
    const filterTree = (val) => {
      var param={
        val:val,
        dataSource:dataSource.value
      }
      //如果是权限配置，不需要过滤
      if(window.location.pathname=='/ConfigPrivilege')
      {
        param.dataSource = 0;
      }
      if (window.location.pathname=='/OverView')
      {
        param.dataSource = 0;
      }

      console.log(mytree)
      console.log(param)
      mytree.value.filter(param)
      console.log(mytree.value)
      expandAll(1)

      if (route.currentRoute.value.query.nodeId!=null) {

        store.state.nodeId = decodeURIComponent(route.currentRoute.value.query.nodeId)
        // mytree.value.setCurrentKey(store.state.nodeId);
        var datas=mytree.value.getNode(decodeURIComponent(route.currentRoute.value.query.nodeId))
        console.log("mytree.value---->",datas)
        handleNodeClick(datas.data,datas,"")
      }

      console.log("filterTree:",treeData)

    }
    onBeforeMount(() => {

      if(route.currentRoute.value.name=="OffLineStatus")
      {
        dataSource.value=4;
      }
      else if(route.currentRoute.value.name=="RealtStatus")
      {
        dataSource.value=1;
      }
      treeData.value=JSON.parse(localStorage.getItem("treeData"));
      console.log(treeData.value);
      if(treeData.value==null)
      {
        treeLoading.value=true;
      }
      getEquip();
    });
    onMounted(()=>{
      filterTree("");
    })
    return {
      filterTree,
      expandAll,
      treeData,
      getEquip,
      renderContent,
      updateTree,
      dataSource,
      mytree,
      tWidth,
      handleNodeClick,
      filterNode,
      filterText,
      changeEquip,
      treeLoading
    }
  }
}
</script>

<style lang="scss">
.aside{
  width: v-bind(tWidth);
  height: calc(100vh - 70px);
  margin-bottom: 10px;
  background-color: #303749;
  overflow: auto;
  .find {
    display: flex;
    justify-content: space-between;
    .find-input {
      .el-input__inner {
        background-color: #303749;
        color: #fff;
      }
      .el-input__inner:focus {
        border-color: #359186;
      }
    }
    .el-button {
      background-color: #2C3242;
      margin-left: 10px;
      color: #fff;
      transition: all 300ms;
    }
    .el-button:hover {
      color: #359186;
      border-color: #359186;
    }
  }
  .el-tree{
    display: inline-block;
    min-width: 100%;
    background-color: #303749;
    color: #fff;
    .el-tree-node .el-tree-node__content{
      background-color: #303749 !important;
    }
    .el-tree-node.is-current > .el-tree-node__content{
      background-color: #359186 !important;
      background-clip:content-box;
    }
    .el-tree-node .el-tree-node__content:hover{
      background-color: #359186 !important;
      background-clip:content-box;
    }
  }
  .el-loading-spinner {
    .path {
      stroke: #359186;
    }
    .el-loading-text {
      color: #359186;
    }
  }

  .level1 {
    color: #e6f600;
  }

  .level2 {
    color: #f4e301;
  }
  .level3 {
    color: #e69924;
  }
  .hLevel {
    color: #ee831f;
  }
  .hhLevel {
    color: #e50a0a;
  }
  .green {
    color: green;
  }
  .duanwang {
    color: rgb(148, 139, 84);
  }
  .tingji {
    color: rgb(190, 190, 190);
  }
}
</style>
